class ToastNotificationManager {
  constructor() {
    this.successToastWrapper = document.getElementById("success-toast-wrapper");
    this.errorToastWrapper = document.getElementById("error-toast-wrapper");
    this.warningToastWrapper = document.getElementById("warning-toast-wrapper");

    this.successToastText = this.successToastWrapper
      ? this.successToastWrapper.querySelector(".toast-text")
      : null;
    this.errorToastText = this.errorToastWrapper
      ? this.errorToastWrapper.querySelector(".toast-text")
      : null;
    this.warningToastText = this.warningToastWrapper
      ? this.warningToastWrapper.querySelector(".toast-text")
      : null;

    this.activeTimeout = null;

    // Initialize close button listeners
    this.initCloseButtons();
  }

  initCloseButtons() {
    const closeButtons = document.querySelectorAll(".toast-close-btn");
    closeButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const toastWrapper = e.target.closest(".toast-wrapper");
        if (toastWrapper) {
          this.hideToast(toastWrapper);
        }
      });
    });
  }

  hideToast(toastWrapper) {
    // Clear any active timeout
    if (this.activeTimeout) {
      clearTimeout(this.activeTimeout);
      this.activeTimeout = null;
    }

    toastWrapper.classList.remove("show");
    toastWrapper.addEventListener(
      "transitionend",
      () => {
        toastWrapper.style.display = "none";
      },
      { once: true }
    );
  }

  show(message, type = "success", duration = 3000) {
    let targetToastWrapper = null;
    let targetToastText = null;

    this.hideAllToastsImmediate();

    if (type === "success" && this.successToastWrapper) {
      targetToastWrapper = this.successToastWrapper;
      targetToastText = this.successToastText;
    } else if (type === "error" && this.errorToastWrapper) {
      targetToastWrapper = this.errorToastWrapper;
      targetToastText = this.errorToastText;
    } else if (type === "warning" && this.warningToastWrapper) {
      targetToastWrapper = this.warningToastWrapper;
      targetToastText = this.warningToastText;
    } else {
      return;
    }

    if (targetToastText) {
      targetToastText.textContent = message;
    }

    targetToastWrapper.style.display = "flex";

    // First add "show" after a short delay
    setTimeout(() => {
      targetToastWrapper.classList.add("show");

      // Now start hide timer only AFTER showing
      this.activeTimeout = setTimeout(() => {
        this.hideToast(targetToastWrapper);
      }, duration);
    }, 50);
  }

  hideAllToastsImmediate() {
    // Clear any active timeout
    if (this.activeTimeout) {
      clearTimeout(this.activeTimeout);
      this.activeTimeout = null;
    }

    if (this.successToastWrapper) {
      this.successToastWrapper.classList.remove("show");
      this.successToastWrapper.style.display = "none";
    }
    if (this.errorToastWrapper) {
      this.errorToastWrapper.classList.remove("show");
      this.errorToastWrapper.style.display = "none";
    }
    if (this.warningToastWrapper) {
      this.warningToastWrapper.classList.remove("show");
      this.warningToastWrapper.style.display = "none";
    }
  }
}

window.toast = new ToastNotificationManager();

document.addEventListener("DOMContentLoaded", () => {
  const toastArea = document.getElementById("toast-area");

  if (toastArea && toastArea.dataset.showToast === "true") {
    const message = toastArea.dataset.message;
    const type = toastArea.dataset.type || "success";
    const duration = parseInt(toastArea.dataset.duration, 10) || 3000;

    if (message) {
      window.toast.show(message, type, duration);
    }
  }
});
